import { Outlet } from "react-router-dom";

const AdminRoute = () => {
  return <Outlet />;
};

export default AdminRoute;